import React from "react";
import { Paper } from "@mui/material";
import { styled } from "@mui/material/styles";

const CustomButton = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  fontWeight: 700,
  paddingTop: 10,
  paddingBottom: 10,
  paddingLeft: 15,
  paddingRight: 15,
  boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.05)",
  borderRadius: 10,
  "&:hover": {
    cursor: "pointer",
  },
}));

const CustomButtonNotClicked = styled(Paper)(({ theme }) => ({
  backgroundColor: "transparent",
  fontWeight: 700,
  paddingTop: 10,
  paddingBottom: 10,
  paddingLeft: 15,
  paddingRight: 15,
  "&:hover": {
    cursor: "pointer",
  },
}));
export default function CustomTopButton(props) {
  const {
    text,
    clicked,
    id,
    onClicked,
    clickedTextColor,
    notClickedTextColor,
    fontSize,
  } = props;

  return clicked ? (
    <CustomButton
      elevation={0}
      onClick={() => onClicked(id)}
      style={{ color: clickedTextColor, fontSize: fontSize }}
    >
      {text}
    </CustomButton>
  ) : (
    <CustomButtonNotClicked
      elevation={0}
      onClick={() => onClicked(id)}
      style={{ color: notClickedTextColor, fontSize: fontSize }}
    >
      {text}
    </CustomButtonNotClicked>
  );
}
